/// <reference path='../_all.ts' />
declare var pglob : IPhotometerGlobalVar;

module library {
  'use strict';

  

  var searchRevision = (doc: Document, hl?: string, fileType?: String): DocumentRev => {
    var ds = doc.Revisions.filter((doc, index, array) => {
      return doc.LanguageCode == hl;
    });
    if (ds.length > 0) return ds[0];
    return null;
  }

  /**
   * Services that persists and retrieves TODOs from localStorage.
   */
  export class LibraryService implements ILibraryService {

    // $inject annotation.
    // It provides $injector with information about dependencies to be injected into constructor
    // it is better to have it close to the constructor, because the parameters must match in count and type.
    // See http://docs.angularjs.org/guide/di
    public static $inject = [
      '$rootScope',
      '$http',
      'anchorNavService',
      '$mdDialog',
      '$filter', 
      '$q', 
    ]; 

    constructor(
      private $rootScope: ng.IRootScopeService,
      private $http: ng.IHttpService,
      private anchorNavService: navigation.IAnchorNavService,
      private $mdDialog: ng.material.IDialogService,
      private $filter : library.IUniqueFilter,
      public $q: ng.IQService,
      ) {}


    public loadDocumentsByProduct(re : IRouteEntry, contentId?:number, categoryId? : number) : ng.IHttpPromise<ServiceData>  {    
      return this.$http<ServiceData>({
        method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Document/ByProduct"
        , headers: { 'Content-Type': 'application/json' }
        , params: { "contentId" : contentId, 'categoryId' : categoryId }
        , data : re.RouteParameterStack
      }).then((response : {data: ServiceData}) : any => {
          //convert Releasedate
          response.data.Documents.forEach((dc) => dc.Types.forEach((t) => t.Documents.forEach((d) => d.Revisions.forEach((rev) => {
            if (rev.ReleaseDate) rev.ReleaseDate = new Date(<any>rev.ReleaseDate); //we recieve that as string, have to convert it.
          }))));
          return response;
      });
    }   
    
    
    public loadDocumentDetails(data: DocumentDetailServiceData, fileSrcRevID : number) : ng.IPromise<DocumentDetailServiceData> { 

      var deferred = this.$q.defer<DocumentDetailServiceData>();
      
      //Revision already loaded?
      if (data && data.Document && data.Document.Revisions &&
          data.Document.Revisions.filter((rev) => { return rev.DocumentFileSrcRevID == fileSrcRevID }).length > 0) {
        this.buildTree(data, fileSrcRevID);
        
        deferred.resolve(data);
        return deferred.promise;
      }
      
      this.$http<DocumentDetailServiceData>({
        method: "GET"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Document/Details"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
            fileSrcRevID: fileSrcRevID
          }
      }).then( (response : {data: DocumentDetailServiceData}) : any => {
        response.data.Document.Revisions.forEach((rev) => {
          if (rev.ReleaseDate) rev.ReleaseDate = new Date(<any>rev.ReleaseDate); //we recieve that as string, have to convert it.
          if (rev.DocumentFileSrcRevExpirationDate) rev.DocumentFileSrcRevExpirationDate = new Date(<any>rev.DocumentFileSrcRevExpirationDate);
          if (rev.DocumentFileSrcRevValidityDate) rev.DocumentFileSrcRevValidityDate = new Date(<any>rev.DocumentFileSrcRevValidityDate);
          if (rev.lastErrataDstDate)rev.lastErrataDstDate = new Date(<any>rev.lastErrataDstDate);
          
        });
        this.buildTree(response.data, fileSrcRevID);
        deferred.resolve(response.data);
      }).catch((err) => {
        deferred.reject(err);
      });

      return deferred.promise;   
    }

    
    public saveDocumentSortOrder(re : IRouteEntry, renumTo, sortOrder: number[], type : DocumentType  ) : ng.IHttpPromise<void> {   
      return this.$http<void>({
        method: "POST"
        , url: "/api/" + pglob.RouteData.CurrentLanguage.hl + "/Document/SaveSortOrder"
        , headers: { 'Content-Type': 'application/json' }
        , params: {
        }
        , data: {
          documentIds : sortOrder,
          type : type,
          renumTo : renumTo,
          rp :re.RouteParameterStack, 
        }
      });
    }

    public openDialog(revid: number, parentScp: any, ev?: MouseEvent) {
      if (ev) ev.preventDefault();

      this.anchorNavService.search("revid", revid);
      this.$mdDialog.show(<ng.material.IDialogOptions>{
        controller: 'LibraryDetailCtrl',
        templateUrl: 'library/LibraryDetailCtrl',
        parent: angular.element(document.body),
        bindToController: true,
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          revId: revid,
          parentScope: parentScp
        },
      }).finally(() => {
        this.anchorNavService.search({ "revid": null });
      });
    }

    

    
    public getDefaultRevision(doc :  Document, hl? : string, fileType? : String) : DocumentRev {
      if (!doc) return null;
      var hl = hl || pglob.RouteData.CurrentLanguage.hl;

      var ds : DocumentRev; 
      ds = searchRevision(doc, hl, fileType);
      if (ds) return ds;

      //otherwise the english one
      if (hl != "E") {
        var ds = searchRevision(doc, "E");
        if (ds) return ds;
      }

      //otherwise the one without language
      if (hl != "X") {
        var ds = searchRevision(doc, "X");
        if (ds) return ds;
      }

      //otherwise the first one 
      var ds1 : library.DocumentRev = doc.Revisions[0];
      if (ds1) return ds1;

      return null;
    }



    /**
     * Builds a tree like Sprache[].Version[].FileType[] that is used to make the 3 filtering drop downs.
     * @param fileSrcRevID (number) the currently selected FileSrcRev to mark active.
     */
    private buildTree(data: DocumentDetailServiceData, fileSrcRevId : number) {
      //build tree    

      //DocumentFileSrcID => Sprache
      //DocumentFileSrcRevID => Version
      //DocumentFileRevDstID => DateiTyp

      data.LanguageVariants = <any>[];

      var fileSrc : {[id : string] : LanguageVariant} = {};
      var fileRevSrc : {[id : string] : Revision} = {};
      var fileType : {[id : string] : FileType} = {};

      data.Document.Revisions.forEach((rev) => {
        //sprachvarianten
        if (!fileSrc[rev.DocumentFileSrcID]) {
          var variant = <LanguageVariant>{
            DocumentFileSrcID : rev.DocumentFileSrcID, 
            Language : this.getDocumentLanguage(data, rev), 
            Revisions : []
          };
          data.LanguageVariants.push(variant);
          fileSrc[rev.DocumentFileSrcID] = variant;
        }

        //revision
        if (!fileRevSrc[rev.DocumentFileSrcRevID]) {
          var revision = <Revision>{
            DocumentFileSrcRevID: rev.DocumentFileSrcRevID, 
            DocumentFileSrcRevName : rev.DocumentFileSrcRevName, 
            Level : rev.Level, 
            ReleaseDate : rev.ReleaseDate,
            FileType : []
          };
          fileSrc[rev.DocumentFileSrcID].Revisions.push(revision);
          fileRevSrc[rev.DocumentFileSrcRevID] = revision;
        }

        //filetype
        //compound key becaue of document which are in progress and not yet have a RevDestId (=Null)
        var key = "" + rev.DocumentFileSrcRevID + "-" + rev.DocumentRevDestID;
        if (!fileType[key]) {
          var filetype = <FileType>{
            DocumentRevDestID : rev.DocumentRevDestID, 
            FileTypeDesc : rev.DocumentRevDestID ? rev.FileTypeExt + " (" + rev.FileTypeName + ")" : "-", 
            DocumentRev : rev
          };
          if (!rev.DocumentRevDestName) filetype.FileTypeDesc = rev.FileTypeName; //papiervorlage
          fileRevSrc[rev.DocumentFileSrcRevID].FileType.push(filetype);
          fileType[key] = filetype;
        }
          
        if (rev.DocumentFileSrcRevID == fileSrcRevId) data.selectedLanguageVariant = fileSrc[rev.DocumentFileSrcID];
        if (rev.DocumentFileSrcRevID == fileSrcRevId) data.selectedRevision = fileRevSrc[rev.DocumentFileSrcRevID];
        if (rev.DocumentFileSrcRevID == fileSrcRevId) data.selectedFileType = fileType[key];
      });

      data.Revision = data.selectedFileType.DocumentRev;
    }

 
    
    private getDocumentLanguage(data: DocumentDetailServiceData, rev : DocumentRev) : string {
      if (!data.Document || !rev) return;
      var revs = data.Document.Revisions.filter((doc) => { 
          return doc.DocumentFileSrcID == rev.DocumentFileSrcID;
      })

      revs = this.$filter('unique')(revs, "LanguageCode");

      var lng = ""
      revs.forEach((rev, i, arr) => {
        lng += this.getLanguage(data, rev.LanguageCode).LanguageName + (arr.length - 1 != i ? ", " : "");
      });
      return lng;
    }

    private getLanguage(data: DocumentDetailServiceData, hlCode : String):Language {
      if (!data.Languages) return null;
      var hl = data.Languages.filter(function (item : Language, index :number, array : Language[]) {
        return item.LanguageCode == hlCode;
      });
      if (hl) return hl[0];
      return null;
    }

    
  }
}